import React from "react"
import { graphql } from "gatsby"
import LayoutGeneral from "../components/organisms/Layout/LayoutGeneral"
import Seo from "gatsby-plugin-wpgraphql-seo"
import { Helmet } from "react-helmet"
import BannerProtocolo from "../components/templates/OthersPage/BannerProtocolo"
import getUri from "../helper/getUri"
export const query = graphql`
  query ($id: ID!) {
    wordpress {
      page(id: $id, idType: DATABASE_ID) {
        title
        uri
        seo {
          title
          metaDesc
          focuskw
          metaKeywords
          metaRobotsNoindex
          metaRobotsNofollow
          opengraphTitle
          opengraphDescription
          opengraphImage {
            altText
            sourceUrl
            srcSet
          }
          twitterTitle
          twitterDescription
          twitterImage {
            altText
            sourceUrl
            srcSet
          }
          canonical
          cornerstone
          schema {
            articleType
            pageType
            raw
          }
        }
        template {
          ... on Wordpress_Template_Protocolo {
            protocolo {
              ...bannerProtocolo
            }
          }
        }
      }
    }
  }
`

export default function Protocolo({ data }) {
  const page = data?.wordpress?.page
  const template = page?.template?.protocolo
  const pageTitle = page?.title

  // if(typeof window !== "undefined"){
  //   let bodyHtml = document.querySelector("body");
  //   bodyHtml.classList.remove("no-scroll");
  // }

  return (
    <LayoutGeneral>
      <Helmet>
        <link rel="canonical" href={getUri(page.seo.canonical)} />
      </Helmet>
      <Seo post={page} />
      <h1 className="d-none">{page.title}</h1>
      <BannerProtocolo
        titulo={pageTitle}
        text={template.texto}
        bgColor={template.colorFondo}
        imagen={template.imagen}
      />
    </LayoutGeneral>
  )
}
